module.exports = "/packs/3-e583c6707958a7e728dd6b1bbc1153f9.svg";